export default __webpack_public_path__ + "static/media/img_partner.f6d06ccf.webp";